import { Component } from '@angular/core';
import { BaseComponent } from "../../views/base.component";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "../../translate";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { EventsService } from "../../lib/EventsService";
import { FilterParams } from "../../models/filter_form.model";
import { ChartParams } from "../../views/chart/chart.component";

import merge from 'lodash-es/merge';
import { SitesService } from "../sites.service";
import { FormControl, FormGroup } from "@angular/forms";
import { RouteProvider } from "../../provider/route.provider";
import { debounceTime, switchMap } from "rxjs/operators";
import { of } from "rxjs";

@Component({
  selector: 'app-action',
  templateUrl: './action.component.html'
})
export class SiteActionComponent extends BaseComponent {
	addFilterParams = {
		period: 'month',
		relativeInverval: {
			type: 'day',
			value: 1,
			border: 300,
		}
	};
	
	conversionChart = new ChartParams({
		axis: {
			y: {
				show: true,
				label: {
					text     : '%',
					position : 'outer-middle'
				}
			}
		},
	});
	
	actionChart = new ChartParams({
		axis: {
			x: {
				label: {
					text     : 'Дата регистрации пользователя',
					position : 'outer-middle'
				}
			},
			y: {
				show: true,
				label: {
					text     : 'Среднее кол-во действий для сайта',
					position : 'outer-middle'
				}
			}
		},
	});
	
	form: FormGroup = new FormGroup({
		value: new FormControl(1),
		type: new FormControl('day'),
		border: new FormControl(300),
	});
	
	constructor(
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public filter: FilterFormService,
		public eventsService: EventsService,
		public routeProvider: RouteProvider,
		public siteService: SitesService,
	) {
		super(eventsService, siteService, activatedRoute, filter, translate);
		
		this.conversionChart.setOptions({
			title: 'Конверсии',
			names: {
				pureConversion: this.translate.__A('site_action.pureConversion'),
				metrickConversion: this.translate.__A('site_action.metrickConversion'),
			},
		});
		
		this.actionChart.setOptions({
			names: {
				avgActionPerPaidSite: this.translate.__A('site_action.avgActionPerPaidSite'),
				avgActionPerFreeSite: this.translate.__A('site_action.avgActionPerFreeSite'),
			},
		});
	}
	
	ngOnInit() {
		super.ngOnInit();
		
		const me = this;

		me.form.valueChanges
			.pipe(
				debounceTime(1000),
				switchMap(({ type, value, border, }) => {
					return of(
						me.routeProvider.navigate(<FilterParams>{
							relativeInverval: {
								type,
								value,
								border,
							},
						})
					)
				})
			)
			.subscribe(() => {
				console.log('form changed!');
			})
	}


	async getData() {
		await this.getConversionCharts();
		await this.getCharts();
	}
	
	
	async getConversionCharts() {
		const me = this;
		const fp = me.filter.filterParams;

		me.conversionChart.showLoader();
		
		// TODO Разобраться почему именно тут нужно явно руками мерджить addFilterParams и FilterParams.
		// FilterService должен разруливать это сам.
		const { charts } = await me.siteService.siteAction.chart(
			merge({}, me.addFilterParams, fp),
			'conversion/charts'
		).toPromise();

		me.conversionChart.data = charts;

		me.conversionChart.hideLoader();
	}
	
	
	async getCharts() {
		const me = this;
		const fp = me.filter.filterParams;

		const title = `Среднее кол-во действий для сайта за период (${fp.relativeInverval.value} ${fp.relativeInverval.type})`;
			
		me.actionChart.setOptions({ title });
		
		me.actionChart.showLoader();
		
		const { charts } = await me.siteService.siteAction.chart(
			merge({}, me.addFilterParams, fp)
		).toPromise();
		
		me.actionChart.data = charts;
		
		me.actionChart.hideLoader();
	}
}
